// import axios from 'axios';

// const environmentUrl = import.meta.env.VITE_APP_BASE_URL;

// // Axios instance for backend API calls
// export const apiAxios = axios.create({
//   baseURL: environmentUrl,
//   timeout: 300000,
//   // headers: { Authorization: 'Bearer ' + getToken() },
//   // withCredentials: true,
// });

// apiAxios.interceptors.request.use(
//   config => {
//     const userId = localStorage.getItem('user_id');
//     if (userId) {
//       config.headers['X-User-Id'] = userId; // or whatever header name your backend expects
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );

import axios from 'axios';
import { authAxios } from './authAxios';
import { getTokens } from '../auth.service';

const environmentUrl = import.meta.env.VITE_APP_BASE_URL;

const getToken = () => {
  return localStorage.getItem('Authorization');
};

const getRefreshToken = () => {
  return localStorage.getItem('RefreshToken');
};

const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem('Authorization', accessToken);
  if (refreshToken) {
    localStorage.setItem('RefreshToken', refreshToken);
  }
};

export const clearTokens = () => {
  localStorage.removeItem('Authorization');
  localStorage.removeItem('RefreshToken');
};

// Axios instance for backend API calls
export const apiAxios = axios.create({
  baseURL: environmentUrl,
  timeout: 300000,
  withCredentials: true,
});

// Request interceptor to add token to every request
apiAxios.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor for token refresh
let isRefreshing = false;
let refreshPromise = null;

apiAxios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // If there is no config, cannot retry → return error
    if (!originalRequest) {
      return Promise.reject(error);
    }

    const status = error.response?.status;

    // Handle 401 errors (backend middleware returns 401 on token errors)
    const isTokenError = (status === 401 || status === 400) && !originalRequest._retry;

    if (isTokenError) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        const refreshToken = getRefreshToken();
        if (!refreshToken) {
          // clearTokens();
          // window.location.href = '/auth';
          // return Promise.reject(error);
        }

        // Use authAxios to refresh the token
        const authBaseUrl = import.meta.env.VITE_AUTH_BASE_URL;
        refreshPromise = axios
          .get(`${authBaseUrl}/Auth/v1.0/refresh-token`, {
            headers: { Authorization: `Bearer ${refreshToken}` },
          })
          .then(async response => {
            const { data } = response.data;

            const tokenResponse = await getTokens({ authcode: data.authcode });
            const { accessToken, refreshToken: newRefreshToken } = tokenResponse.data.data;

            setTokens(accessToken, newRefreshToken);
            return accessToken;
          })
          .catch(refreshError => {
            // clearTokens();
            console.log(refreshError);

            // window.location.href = '/auth';
            throw refreshError;
          })
          .finally(() => {
            isRefreshing = false;
            refreshPromise = null;
          });
      }

      try {
        const newToken = await refreshPromise;
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return apiAxios(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
